import get from 'lodash/get';
import merge from 'lodash/merge';
import moulages from '../../config/moulages';

const messages = {
  'DISTENSION_MEDIUM': 'Gastric distension medium is not available for obese patients',
  'DISTENSION_SMALL': 'Gastric distension small is not available for obese patients',
  'FRACTURE_CLOSED_UPPER': 'Upper leg fracture is not available for obese patients',
}

function validateAvatar(caseConf) {
  const errors = [];

  const combined = merge(
    {},
    get(caseConf, 'moulages', {}),
    get(caseConf, 'structuralMoulages', {}),
  )
  const bodyType = caseConf._avatar.avatarOptions.bodyType;
  for (const [location, moulageKey] of Object.entries(combined)) {
    const moulage = moulages.find(m => m.key === moulageKey);
    if (moulage && moulage.bodyTypeRestrictions) {
      const isRestricted = moulage.bodyTypeRestrictions[location] === bodyType;
      if (isRestricted) {
        const message = messages[moulageKey] || 'Moulage is not available for current patient';
        errors.push({ 
          message, 
          category: 'patientConditions', 
          field: 'moulage' 
        });
      }
    }
  }

  return {
    errors,
    warnings: [],
  };
}

export default validateAvatar;
